// Which attachments a browser tab can show (instead of only downloading them).
// KEEP IN SYNC with backend/utils/openableFile.js: the chat opens exactly these files in a tab,
// and only these count as "new documents" until the receiver opens them.
//
// Returns the type to show the file as, or null when it can only be downloaded (dll, exe, zip,
// office files, ...). Text-like files are shown as plain text. HTML and SVG are never shown:
// opened from a blob they would run scripts with the app's permissions.
const TEXT_FILE = /\.(txt|md|markdown|log|csv|tsv|json|xml|ya?ml|ini|cfg|conf|properties|js|jsx|ts|tsx|css|py|java|c|h|cpp|hpp|cs|go|rs|sh|bat|ps1|sql)$/i

export const getBrowserViewType = (type = '', name = '') => {
  type = String(type || '').split(';')[0].trim()
  name = String(name || '')

  if (/html|svg/i.test(type) || /\.(html?|xhtml|xht|svgz?)$/i.test(name)) return null
  if (/^image\/(png|jpe?g|gif|webp|bmp|avif|x-icon|vnd\.microsoft\.icon)$/.test(type)) return type
  if (/^(video|audio)\//.test(type) || type === 'application/pdf') return type
  if (
    type.startsWith('text/') ||
    /^application\/(json|xml|javascript|x-yaml|yaml)$/.test(type) ||
    TEXT_FILE.test(name)
  ) {
    return 'text/plain;charset=utf-8'
  }
  return null
}

export const isOpenableFile = (type, name) => Boolean(getBrowserViewType(type, name))

// A received, readable attachment I have not opened yet. `message` is a chat message or an item of
// the Files / Photos tab; `meId` is my user id (string).
export const isNewAttachment = (message, meId) => {
  const a = message?.attachment
  if (!a?.url || message.deletedAt) return false
  if (String(message.senderId) === String(meId)) return false
  if (message.isNew !== undefined) return message.isNew === true       // items from /attachments carry the flag
  if ((message.attachmentOpenedBy || []).map(String).includes(String(meId))) return false
  return isOpenableFile(a.type, a.name)
}
